import { styled } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';

export const StyledSyncIcon = styled(SyncIcon)(({ theme }) => ({
  height: 20,
  transition: 'opacity 0.2s ease, color 0.2s ease',
}));
